import { render } from "./stock-bound-editor.vue?vue&type=template&id=7d31bb76"
import script from "./stock-bound-editor.vue?vue&type=script&lang=js"
export * from "./stock-bound-editor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__